import { REPORT_TYPES } from './reportTypes'

// FAQ data for each report type
export const FAQ_DATA = {
  [REPORT_TYPES.INCORRECT_CONTENT]: [
    {
      title: 'How To Edit Artist Profile',
      description: 'Guide for managing artist profiles in FAST, including uploading artist image, adding social media, merch, and tour links',
      url: 'https://artists.feelsmusic.com/edit-artist-profile'
    },
    {
      title: 'How To Edit / Change Incorrect Lyrics',
      description: 'Guide for changing any incorrect lyrics in FAST',
      url: 'https://artists.feelsmusic.com/update-lyrics'
    },
    {
      title: 'How To Add Tags',
      description: 'How to add official tags to your artist’s Feels Music Messages',
      url: 'https://artists.feelsmusic.com/how-to-add-tags'
    },
    {
      title: 'How To Utilize Backdrop',
      description: 'Backdrop provides the option to upload an alternative creative asset for any song in place of the static cover art / when an official music video doesn\'t exist or if there\'s a more preferential visual asset to use for a Feels Music Message than the existing music video.',
      url: 'https://artists.feelsmusic.com/how-to-utilize-backdrop'
    },
    {
      title: 'How To Use the Feels Retiming Tool',
      description: 'If you\'ve replaced an audio only version of a song with an official video, the lyrics won\'t always line up exactly the same - in this case you will need to make adjustments to your audio/video timing so the lyrics align properly; you can do this easily by using the Feels Retiming Tool.',
      url: 'https://artists.feelsmusic.com/feels-retiming-tool'
    },
    {
      title: 'How To Use the Feels Retiming Tool - ADVANCED VERSION',
      description: 'An additional resource explaining the Feels Retiming Tool which includes keyboard shortcuts and additional details for those advanced users',
      url: 'https://artists.feelsmusic.com/advanced-retiming-tool'
    }
  ],
  [REPORT_TYPES.ADD_ARTIST_TO_ORG]: [
    {
      title: 'How Do I View All Artists I Manage or that are on my Label?',
      description: 'When you log into the Feels Artist Studio & Tools (FAST) admin dashboard, click on the "Artists" tab to view all artists you’re granted access to in alphabetical order. You can also search by artist name to avoid scrolling through the list.',
      url: 'https://artists.feelsmusic.com/view-artists'
    }
  ],
  [REPORT_TYPES.MISSING_CONTENT]: [
    {
      title: 'When an artist changes labels how to switch over FAST admin access?',
      description: 'How to gain access to an artist’s FAST when the artist has been newly signed or switched labels (form required)',
      url: 'https://artists.feelsmusic.com/how-to-gain-access'
    },
    {
      title: 'What happens if I don’t see my artist’s content on their Feels Profile?',
      description: 'How to flag missing songs or albums from an artist’s Feels profile (form required)',
      url: 'https://artists.feelsmusic.com/missing-song'
    }
  ],
  [REPORT_TYPES.DISASSOCIATE_CONTENT]: [
    {
      title: 'How do I hide / dissociate a song from my artist\'s profile?',
      description: 'Guide for how to hide a song on an artist’s profile as well as additional steps to have it completely removed (form required)',
      url: 'https://artists.feelsmusic.com/dissociate-content-from-profile'
    },
    {
      title: 'When an artist changes labels how to switch over FAST admin access?',
      description: 'How to gain access to an artist’s FAST when the artist has been newly signed or switched labels (form required)',
      url: 'https://artists.feelsmusic.com/how-to-gain-access'
    },
    {
      title: 'How To Lock A Song',
      description: 'Feature that prohibits users from generating their own Feels Music Messages (Feels) from an artist’s song, only permitting the artist’s FAST admin to create and publish Feels from the song',
      url: 'https://artists.feelsmusic.com/how-to-lock-a-song'
    },
    {
      title: 'How To Hide A Song',
      description: 'Definition of and guide to using the "Hide" feature in FAST',
      url: 'https://artists.feelsmusic.com/how-to-hide-a-song'
    },
    {
      title: 'What does Unpublished mean?',
      description: 'Explanation of the Published/Unpublished feature and how to utilize it in FAST',
      url: 'https://artists.feelsmusic.com/how-to-unpublish-a-feels'
    }
  ],
  [REPORT_TYPES.OTHER]: [
    {
      title: 'Check This Out Before Submitting a Report',
      description: 'This page includes helpful links and FAQs that may resolve your issue without needing to submit a report.',
      url: 'https://artists.feelsmusic.com/help'
    }    
  ] 
}
